export default __webpack_public_path__ + "static/media/code-rebase.08c36010.svg";